import { CreatedInterfaces } from '../../interfaces';
import { useGetRequest } from '../utils/useGetRequest';

const resource = 'card-affinity-groups-all';

interface CardAffinityGroupParams {
  name?: string,
  active?: boolean,
  sort?: string,
}

const parameterToParamMap = {
  name: 'name',
  sort: 'sort'
};
const useGetCardAffinityGroups = (page: number, size: number, cardAffinityGroup: CardAffinityGroupParams) => {

  let path = `v1/card_affinity_groups?page=${page}&size=${size}`;
  path += cardAffinityGroup?.active !== undefined ? `&active=${cardAffinityGroup?.active}` : ``;

  Object.entries(cardAffinityGroup || []).forEach(([param, value]) => {
    if (value && param in parameterToParamMap) {
      path += `&${parameterToParamMap[param]}=${value}`;
    }
  });

  const [{ data, error, loading }, execute ] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: path
  });

  return {
    affinityGroups: data?.data,
    pageInfo: {
      ...data?.meta
    },
    loading,
    error,
    getCardAffinityGroups: execute
  }
}

export default useGetCardAffinityGroups;